import { useState, useRef, useEffect } from "react";
import styles from "../../../../../../components/templates/Filters/Filters.module.scss";
import { X } from "react-feather";
import Button from "@components/base/button";

const filterOptionsData = [
  { key: "vocc", label: "VOCC" },
  { key: "nvocc", label: "NVOCC" },
  { key: "freight_forwarder", label: "Freight Forwarder" },
];

export const LogisticsFilter = ({ sendingDataToSearch }) => {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [filterCount, setFilterCount] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  });

  const handleClickOutside = (e) => {
    if (showFilter && !divRef?.current?.contains(e.target)) {
      setShowFilter(false);
    }
  };
  const handleToggle = (key) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = { ...prevFilters, [key]: !prevFilters[key] };
      const activeFilters = Object.values(newFilters).filter(Boolean).length;
      setFilterCount(activeFilters);
      return newFilters;
    });
  };

  const callingAPI = () => {
    const activeFilters = Object.keys(selectedFilters).filter((k) => selectedFilters[k]);
    sendingDataToSearch(activeFilters);
  };

  const clearAllFilters = () => {
    setSelectedFilters({});
    setFilterCount(0);
    sendingDataToSearch([]);
  };

  const removeSelectedFilters = () => {
    setSelectedFilters({});
    setFilterCount(0);
  };

  return (
    <div style={{ position: "relative", lineHeight: "0px !important" }} ref={divRef}>
      <Button
        variant="secondaryWithIcon"
        size="small"
        className="tw-ml-1 tw-mr-2 tw-font-medium tw-text-sm tw-flex tw-items-center disabled:tw-cursor-not-allowed"
        onClick={(e) => {
          e.stopPropagation();
          setShowFilter(!showFilter);
        }}
        id="dropdownMenuButton">
        <span className="material-symbols-outlined">tune</span>
        <span>Filter by</span>
        {filterCount > 0 ? (
          <span className={`ml-2 ${styles.filter_count}`}>
            {filterCount}
            <X
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                clearAllFilters();
              }}
              size={16}
            />
          </span>
        ) : null}
      </Button>

      {showFilter && (
        <div onClick={(e) => e.stopPropagation()} className={styles.singleFilterContainer} style={{ width: "270px", right: "2px", lineHeight: "0px !important" }}>
          <div className="tw-flex tw-gap-1 tw-justify-between tw-items-center tw-px-2 tw-py-1">
            <div className="tw-text-sm tw-font-medium">Filter By Type</div>
            <div className="d-flex align-items-center tw-gap-2">
              {filterCount > 0 ? (
                <div
                  className="tw-bg-white tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-rounded-md tw-cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeSelectedFilters();
                  }}>
                  Clear
                </div>
              ) : (
                ""
              )}

              {filterCount > 0 ? (
                <div
                  className="tw-bg-primary-purple-500 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-rounded-md tw-cursor-pointer tw-text-white"
                  onClick={() => {
                    callingAPI();
                    setShowFilter(!showFilter);
                  }}>
                  Apply
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          {filterOptionsData.map((item) => (
            <div className="tw-flex tw-items-center" key={item.key}>
              <div className="form-check ml-2 tw-my-1">
                <input type="checkbox" className="form-check-input" checked={selectedFilters[item.key] || false} onChange={() => handleToggle(item.key)} />
                <span className="form-check-label tw-text-xs">{item.label}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
